import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import React, { useRef, useState } from 'react';

type NATConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmLabel?: React.ReactNode;
};

export function NATConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
}: NATConfirmationModalProps) {
  const [isProcessing, setIsProcessing] = useState(false);
  const initialRef = useRef(null);

  const handleConfirm = () => {
    setIsProcessing(true);
    onConfirm();
    setIsProcessing(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} initialFocusRef={initialRef} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title != null ? title : <Trans>Confirm Export</Trans>}</ModalHeader>
        <ModalBody>
          <Text>
            {message != null ? message : <Trans>Are you sure you want to export this file?</Trans>}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Flex gap={2}>
            <Button size="sm" variant="ghost" onClick={onClose}>
              <Trans>Cancel</Trans>
            </Button>
            <Button
              size="sm"
              variant="solid"
              onClick={handleConfirm}
              ref={initialRef}
              isLoading={isProcessing}
              isDisabled={isProcessing}
            >
              {confirmLabel ?? <Trans>Confirm export</Trans>}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
